import * as Yup from 'yup';

export const reportSchema = Yup.object({
  name: Yup.string('Enter report name').required('Report name is required'),
  link: Yup.string('Enter report link')
    .required('Report link is required')
    .url('Report link must be a valid URL')
});
